import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BatchRequirementService } from '@services/bathupdaterequirement.service';
import { LoadingService } from '@services/loading.service';
import { RequirementTypesService } from '@services/requerimenttypes.service';
import { ResponseObjectAPI } from 'src/app/models/responseObjectAPI';
import { RequirementService } from 'src/app/services/requirement.service';

@Component({
    selector: 'batch-assing-requirement-dialog',
    templateUrl: './batch-assing-requirement-dialog.component.html',
    styleUrls: ['./batch-assing-requirement-dialog.component.scss'],
    standalone: false
})


export class BatchAssingRequirementDialogComponent implements OnInit {

  returning = false;
  form = new FormGroup({
		commentArea: new FormControl('')
  });

  @Input() requirementIds;
  @Output() assigned = new EventEmitter();
  @Input() userId: null;
  customfieldsRequirementType;
  visibilityId: number;

  constructor(
    public activeModal: NgbActiveModal,
    public requirementService: RequirementService,
    public requirementTypesService:RequirementTypesService,
    private batchRequirementService:BatchRequirementService,
    private _loading: LoadingService
    ) { }

    isValidate: boolean = false;
    actionid:number;
    users:[]
    isSubmitting = false;


    async ngOnInit() {

      const body = {
        requirementids: this.requirementIds
      };

      this.batchRequirementService.getAssigmentUser(body).subscribe((resp:any) => {
        this.users= resp.result.data;
     });
    }


  onSubmit() {

  }

  onValueUserChange(value){
    this.userId = value
    this.isValidate = true

  }


  async saveDataToChangeStatus() {
    if (this.isSubmitting) return;

    try {
      this.isSubmitting = true;
      this._loading.reloadStart(null,this._loading.blockUIList);
      const body = {
         requirementids: this.requirementIds,
         userid: this.userId
      };
      this.batchRequirementService.setAssigmentUser(body).subscribe((resp: ResponseObjectAPI) => {
        this.assigned.emit(true);
      });
    } finally {
      this.isSubmitting = false;
    }
  }
}
